import ReviewCard from './review-card'
export default ReviewCard
